module.exports = __webpack_public_path__ + "img/package-return.16c1adaf.jpg";